import React, {Component} from 'react';
import '../../../css/pages/overview/Guestbook.css'
import Button from "@material-ui/core/Button/Button";
import {GetWithAuth} from "../../api/client/Get";
import {PutWithAuth} from "../../api/client/Put";
import {DeleteWithAuth} from "../../api/client/Delete";

class GuestbookPending extends Component {

    constructor(props) {
        super(props);

        this.state = {
            posts: [],
            pending: []
        };

        // during dev change URL to "./data/guestbookData.json"
        GetWithAuth("/api/admin/guestbook", this.props.token)
            .then((res) => {
                this.setState({
                    posts: res.data.posts,
                    pending: res.data.pending
                })
            });
    }

    deleteCurrent = (postId) => {
        DeleteWithAuth("/api/guestbook/" + postId, this.props.token);

        const current = this.state.posts.filter(p => p.postId !== postId);

        this.setState({
            posts: current
        });
    };

    acceptPost = (post) => {
        PutWithAuth("/api/guestbook/" + post.postId + "/accept", this.props.token);

        const acceptedPosts = this.state.posts;
        acceptedPosts.push(post);

        const pending = this.state.pending.filter(p => p.postId !== post.postId);

        this.setState({
            posts: acceptedPosts,
            pending: pending
        });
    };

    deletePending = (postId) => {
        DeleteWithAuth("/api/guestbook/" + postId, this.props.token);

        const current = this.state.pending.filter(p => p.postId !== postId);

        this.setState({
            pending: current
        });
    };

    render() {
        return (
            <div id={"guestbook_pending"}>
                <h1>Pending Comments</h1>
                <div className={"guestbook_scrollbox"}>
                    {
                        this.state.pending.length === 0 ?
                            <p className={"small_info"}>No new comments!</p> :
                            this.state.pending.map((post) => (
                                <div key={post.postId} className={"guestbook_post"}>
                                    <p>{post.comment}</p>
                                    <hr/>
                                    from <h4>{post.guestName}</h4>
                                    <div className={"br_options"}>
                                        <table className={"even_spaced_table br_buttons"}>
                                            <tbody>
                                            <tr>
                                                <td>
                                                    <Button variant="outlined" color="primary"
                                                            onClick={e => this.acceptPost(post)}>
                                                        ACCEPT
                                                    </Button>
                                                </td>
                                                <td>
                                                    <Button variant="outlined" color="secondary"
                                                            onClick={e => this.deletePending(post.postId)}>
                                                        DELETE
                                                    </Button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))
                    }
                </div>

                <h1>Current Guestbook</h1>
                <div className={"guestbook_scrollbox"}>
                    {
                        this.state.posts.map((post) => (
                            <div key={post.postId} className={"guestbook_post"}>
                                <p>{post.comment}</p>
                                <hr/>
                                from <h4>{post.guestName}</h4>
                                <div className={"br_options"}>
                                    <table className={"even_spaced_table br_buttons"}>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <Button variant="outlined" color="secondary"
                                                        onClick={e => this.deleteCurrent(post.postId)}>
                                                    DELETE
                                                </Button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }
}

export default GuestbookPending;